// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"1d8c2be3","51":"62576cd8","56":"40813798","68":"75ac3399","174":"807426a4","212":"8b4d231a","318":"924a3ea9","751":"53ae4072","981":"91bf537a"}[chunkId] + ".chunk.js";
};